import React from 'react';
import Trans from 'next-translate/Trans';
import { Alert, NextLink } from '@dotone/react-ui-core';

const DocsApiKeyRequiredContainer = ({ apiKey, children }) => {
  return apiKey ? (
    children
  ) : (
    <Alert variant="warning">
      <Trans
        i18nKey="docs:hints.apiKeyRequired"
        components={[<NextLink key="link" href="/advertisers/api-keys" />]}
      />
    </Alert>
  );
};

export default DocsApiKeyRequiredContainer;
